module.exports = {"440811070":"东山街道办","440811071":"东简街道办","440811072":"民安街道办","440811100":"麻章镇","440811101":"太平镇","440811102":"湖光镇","440811173":"硇洲镇","440811450":"湖光农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440811.json
// module id = 2000
// module chunks = 0